import React from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import Link from 'react-router-dom/Link';
import moment from 'moment';

const LandROWTable = ({ Land }) => {
  const commonWidth = '15%'
  const commonHeight = '30px'
  const columns = [
    {
      title: 'Project ID',
      field: 'id',
      render: (rowData) => (
        <Link to={`/RightOfWays/${rowData.id}?name=${encodeURIComponent(rowData.projectName)}`}>
          {rowData.projectName}
        </Link>
      ),
    },
    { title: 'Status',
      field: 'status',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
    },

    { title: 'Lessee',
      field: 'lessee',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
    },

    { title: 'Type',
      field: 'type',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
    },
    {
      title: 'Expiration Date',
      field: 'dateOfExpiration',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
      render: (rowData) => moment(rowData.dateOfExpiration).format('MM/DD/YYYY'),
    },
  ];

  const pageLength = Land.rowsOn.length;

  return (
    <MaterialTable
      title=""
      columns={columns}
      data={Land.rowsOn.map((r) => ({ ...r }))}
      options={{
        paging: false,
        search: false,
        pageSize: pageLength,
        // maxBodyHeight: 'calc(100vh - 150px)',
        // // searchFieldAlignment: 'left',
        // // searchFieldStyle: {
        // //   backgroundColor: '#fff',
        // //   color: '#000',
        // //   border: 'none',
        // //   padding: '4px 8px',
        // //   borderRadius: '4px',
        // // },
        showTitle: false,
        // toolbarButtonAlignment: 'left',
        // addRowPosition: 'first',
        exportButton: false,
        headerStyle: {
          backgroundColor: '#1976d2',
          color: '#FFF',
          textAlign: 'left',
          justifyContent: 'center',
          whiteSpace: 'pre',
        },
      }}
      components={{
        Toolbar: (props) => (
          <div
            style={{
              height: 16,
              width:"100%",
              marginTop: -30,
              backgroundColor: '#1976d2',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 20,
            }}
          >
            <MTableToolbar {...props} />
          </div>
        ),
      }}
    />
  );
};

export default LandROWTable;
